import {
    CREATE_FABRIC_PO_DETAILS_REQUEST,
    CREATE_FABRIC_PO_DETAILS_SUCCESS,
    CREATE_FABRIC_PO_DETAILS_FAILURE,
    DELETE_FABRIC_PO_DETAILS_REQUEST,
    DELETE_FABRIC_PO_DETAILS_SUCCESS,
    DELETE_FABRIC_PO_DETAILS_FAILURE,
    FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST,
    FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS,
    FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE,
    FETCH_FABRIC_PO_DETAILS_REQUEST,
    FETCH_FABRIC_PO_DETAILS_SUCCESS,
    FETCH_FABRIC_PO_DETAILS_FAILURE,
    UPDATE_FABRIC_PO_DETAILS_REQUEST,
    UPDATE_FABRIC_PO_DETAILS_SUCCESS,
    UPDATE_FABRIC_PO_DETAILS_FAILURE,
    RESET_FABRIC_PO_DETAILS_INFO,
    CREATE_FABRIC_PO_DETAILS_FORM,
    UPDATE_FABRIC_PO_DETAILS_FORM,
    FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST,
    FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS,
    FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST,
    FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE,
    FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS,
    FABRIC_PO_DETAILS_USERFORM_SELECTED_ROWS,
    RESET_STATE_FABRIC_SELECTED_DATA,
    FETCH_DIA_DETAILS_DIA_FROM_STYLE_SUCCESS,
    FETCH_DIA_DC_DETAILS_DIA_FROM_STYLE_FAILURE,
    FETCH_DIA_DETAILS_DIA_FROM_STYLE_REQUEST,
    FETCH_FABRIC_PO_DETAILS_GAGE_FROM_STYLE_SUCCESS,
    FETCH_FABRIC_PO_DETAILS_GAGE_FROM_STYLE_REQUEST,
    FETCH_FABRIC_PO_DETAILS_GAGE_FROM_STYLE_FAILURE,
    FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_SUCCESS,
    FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_FAILURE,
    FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_REQUEST,
    FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_REQUEST,
    FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_SUCCESS,
    FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_FAILURE,
    PREVLIST_LOADER_INDICATION,
    FETCH_CURRENT_RATE_FROM_STYLE_SUCCESS,
    RESET_FABRIC_PO_DETAILS_LIST,
    EDIT_API_SELECTED_ROWS_CALL_SUCCESS,
    EDIT_API_SELECTED_ROWS_CALL_REQUEST,
    EDIT_API_SELECTED_ROWS_CALL_FAILURE,
    CREATE_USER_FORM_FABRIC_PO_GENERATE_QTY
} from './fabricPoDetails.actionsType';

export const FABRIC_PO_DETAILS = 'fabricPoDetails';

let initialState = {
    loading: false,
    fabricPoDetails: [],
    fabricPoDetailsWithoutId: [],
    groupList: [],
    selectedRows: [],
    fabricPoDetailsForm: {
        fldRatePerKG: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldIsCora: false,
        fldCoraGSM: false,
    },
    previousList: [],
    selectedState: {},
    errorMessage: '',
    DiaFromStylePre: [],
    GaugeStyleLists: [],
    LoopStyleLists: [],
    previousGetLoader: true,
    editSelectedRows: [],
    editFabricQtyList1: [],
};


export let fabricPoDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;


    switch (type) {
        case FETCH_FABRIC_PO_DETAILS_REQUEST:
        case CREATE_FABRIC_PO_DETAILS_REQUEST:
        case UPDATE_FABRIC_PO_DETAILS_REQUEST:
        case FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST:
        case DELETE_FABRIC_PO_DETAILS_REQUEST:
        case FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST:
        case FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST:
        case FETCH_DIA_DETAILS_DIA_FROM_STYLE_REQUEST:
        case FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_REQUEST:
        case EDIT_API_SELECTED_ROWS_CALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoDetails: updatePayload
            };
        case EDIT_API_SELECTED_ROWS_CALL_SUCCESS:
            return {
                ...state,
                loading: false,
                editSelectedRows: updatePayload
            }
        case FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };

        case RESET_FABRIC_PO_DETAILS_LIST:
            return {
                ...state,
                previousList: []
            }
        case FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoDetailsWithoutId: updatePayload
            };

        case FETCH_DIA_DETAILS_DIA_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                DiaFromStylePre: updatePayload
            };
        case PREVLIST_LOADER_INDICATION: {
            return {
                ...state,
                loading: false,
                previousGetLoader: payload
            }
        }
        case FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case FABRIC_PO_DETAILS_USERFORM_SELECTED_ROWS:
            return {
                ...state,
                loading: false,
                selectedRows: payload
            };
        case RESET_STATE_FABRIC_SELECTED_DATA:
            return {
                ...state,
                loading: false,
                selectedRows: updatePayload.selectedRows
            };
        case CREATE_USER_FORM_FABRIC_PO_GENERATE_QTY:
            return {
                ...state,
                loading: false,
                editFabricQtyList1: payload
            }
        case CREATE_FABRIC_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
            };
        case UPDATE_FABRIC_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS:

            let temp = {
                fldFabricGroupDescription: updatePayload?.fldFabricGroup,
                fldColor: updatePayload?.fldColour,


            }
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: updatePayload,
                editFabricQtyList1: [{
                    ...updatePayload,
                    fldFKStyleNumber: updatePayload?.fldFKStyleNumber,
                    fldFKSaleOrderNo: updatePayload?.fldFKSaleOrderNo,
                    fldFKColor: updatePayload?.fldFKColour,
                    fldFabricGroupDescription: updatePayload?.fldFabricGroup,
                    fldColor: updatePayload?.fldColour,
                    fldFabric: updatePayload?.tblFabricname,
                    fldYarnCount: updatePayload?.fldFKYarnCountsID.fldDescription,
                    fldGauge: updatePayload?.fldGage,
                    fldLoopLength1: updatePayload?.fldLoopLength,
                    fldPendingQty: updatePayload?.fldQuantity,
                    fldPoQty: updatePayload?.fldNettRequirement || 0,
                    fldNettRequirement: updatePayload?.fldQuantity,
                    fldCostPerKg: updatePayload?.fldRate

                }],
            };
        case FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                GaugeStyleLists: updatePayload,
                fabricPoDetailsForm: {
                    ...state.fabricPoDetailsForm,
                    fldGage: updatePayload[0]
                }

            };
        case FETCH_CURRENT_RATE_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                currentRateChecker: updatePayload
            }
        case FETCH_LOOP_DETAILS_LOOPLENGTH_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                LoopStyleLists: updatePayload,
                fabricPoDetailsForm: {
                    ...state.fabricPoDetailsForm,
                    fldLoopLength: updatePayload[0]
                }
            };
        case DELETE_FABRIC_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };

        case RESET_FABRIC_PO_DETAILS_INFO:
            return {
                ...state,
                fabricPoDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                editFabricQtyList1: []
            };
        case CREATE_FABRIC_PO_DETAILS_FORM:
        case UPDATE_FABRIC_PO_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                fabricPoDetailsForm: {
                    ...state.fabricPoDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FABRIC_PO_DETAILS_FAILURE:
        case CREATE_FABRIC_PO_DETAILS_FAILURE:
        case UPDATE_FABRIC_PO_DETAILS_FAILURE:
        case FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE:
        case DELETE_FABRIC_PO_DETAILS_FAILURE:
        case FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE:
        case FETCH_DIA_DC_DETAILS_DIA_FROM_STYLE_FAILURE:
        case FETCH_GAUGE_DETAILS_GAUGE_FROM_STYLE_FAILURE:
        case EDIT_API_SELECTED_ROWS_CALL_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
